module.exports = __webpack_public_path__ + "static/media/seed2.7e9a5a66.png";